import React, {useState} from 'react';
import {Box, Button, Drawer, FormControl, FormHelperText, FormLabel, Grid, IconButton, TextareaAutosize, TextField, Tooltip, Typography} from "@mui/material";
import FormDateInput from "../../../../components/form/FormDateInput";
import {MdDeleteOutline} from "react-icons/md";
import {confirmation, handleDelete, parseTime, timeSlots} from "../../../../services/utills";
import * as yup from "yup";
import * as Yup from "yup";
import {useFormik} from "formik";
import {storeBlockHour, storeStaffBreakTime} from "../../../../store/clinics/clinicSettings/business-hours";
import {useDispatch} from "react-redux";
import {useParams} from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import {inputStyle} from "../../../../components/form/formInput";
import CustomButtoncolor from '../../../../components/custom-button/customColorButton';
import Waveloading from '../../../loading/Waveloading';
import CloseIcon from '@mui/icons-material/Close';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import toast from "react-hot-toast";
import { NOTE_MAX_LENGTH, noteLimitError } from '../../../../utils/noteLimits';

const BURGUNDY = '#A72C68';
const BURGUNDY_DARK = '#921F58';
const PINK_BG = '#FAEFF5';
const PINK_BORDER = '#F0CDDB';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    p: '41px 23px',
    borderRadius:'6px',
    '@media (max-width: 480px)': {
      width: "95%",
      p: '31px 13px',
    },
    gap:"5px"
  };


  const labelStyles ={
    color:'#000',
    fontSize:'16px',
    mb:'10px',
    "&.Mui-focused": {
        color:'#000!important',
    }
}
const StaffBreakTimeModal = ({onRescheduleSuccess,staff_id, marginBlock}) => {
    const [open, setOpen] = useState(false);
    const [loading,setLoading] = useState(false)
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const dispatch = useDispatch()
    const params = useParams()


    const validationSchema = yup.object({
        notes: yup.string().min(3, "Notes  is Too Short").required('Notes is required'),
        date: Yup.date().typeError("Staff holiday date is required").required("Staff holiday date is required"),
        start_time: yup
            .date()
            .transform((value, originalValue) =>
                originalValue ?  parseTime(originalValue) : null
            )
            .required("Start time is required").typeError("Start time is required"),
        end_time: yup
            .date() 
            .transform((value, originalValue) =>
                originalValue ? parseTime(originalValue) : null
            )
          
            .required("End time is required").typeError("End time is required")
            .min(yup.ref("start_time"), "End time must be after start time"),
    });


    const {values, handleSubmit, setFieldValue,resetForm, handleChange, touched, errors} = useFormik({
        initialValues: {
            date: '',
            start_time: '',
            end_time: '',
            notes:'',
        },
        validationSchema: validationSchema,
        onSubmit: async (data, {setFieldTouched, setFieldError}) => {
            setLoading(true)

            let res = await dispatch(storeBlockHour({...data}))
            //console.log(res?.payload)
            if (res?.payload?.errors) {

                const {errors} = res?.payload
                if (errors) {
                    toast.error(errors, { duration: 5000 });
                }
                if (errors?.date) { 
                    setFieldTouched("date", true)
                    setFieldError("date", errors?.date)
                }
                if (errors?.start_time) {
                    setFieldTouched("start_time", true)
                    setFieldError("start_time", errors?.start_time)
                }
                if (errors?.end_time) {
                    setFieldTouched("end_time", true)
                    setFieldError("end_time", errors?.end_time)
                }
                if (errors?.notes) {
                    setFieldTouched("notes", true)
                    setFieldError("notes", errors?.notes)
                }
                if (onRescheduleSuccess) {
                    onRescheduleSuccess();
                }
                setLoading(false)
            } else if (res?.payload?.success === "true") {
                resetForm()
                if (onRescheduleSuccess) {
                    onRescheduleSuccess();
                }
                setLoading(false)
                handleClose()
            }
        },
    });


    const handleDeleteStaffBreak = async (row) => {
        if (await confirmation()) {
            setLoading(true);
            let finalData = { 
                id: row?.id,
                provider_id: params?.clinic_id,
                staff_id: staff_id,   
            }
            await handleDelete(dispatch, "staffBreak", finalData);
            setLoading(false);
        }
    }


    return (
        <Grid container>

             <Button
                                sx={{
                                    background: 'linear-gradient(135deg,#A72C68 0%,#921F58 100%)',
                                    color: '#fff',
                                    borderRadius: '9px',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    px: { xs: 1.5, sm: 2.5 },
                                    height: '38px',
                                    fontSize: '14px',
                                    whiteSpace: 'nowrap',
                                    boxShadow: 'none',
                                    width: 'auto',
                                    minWidth: 0,
                                    marginRight: { sm: 2, xs: marginBlock || 0, lg: 0, md: 0 },
                                    marginBottom: 0,
                                    "&:hover": {
                                      background: 'linear-gradient(135deg,#921F58 0%,#6E1A42 100%)',
                                      boxShadow: 'none',
                                    },
                                  }}
                               onClick={handleOpen}
                                variant={'contained'}>
                                Block Hours
                            </Button>

            {/* Add Block Hours — right-side panel (matches appointment-detail style) */}
            <Drawer
                anchor="right"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        width: { xs: '100%', sm: 480, md: 540 },
                        maxWidth: '100vw',
                        background: '#fff',
                        boxShadow: '-12px 0 40px rgba(0,0,0,0.10)',
                        display: 'flex',
                        flexDirection: 'column',
                    },
                }}
            >
                {/* Header */}
                <Box sx={{
                    position: 'relative',
                    display: 'flex', alignItems: 'flex-start', gap: 1.25,
                    px: 2.5, py: 2,
                    borderBottom: `1px solid ${PINK_BORDER}`,
                    flexShrink: 0,
                }}>
                    <Box sx={{
                        width: 42, height: 42, borderRadius: '10px',
                        background: PINK_BG, border: `1px solid ${PINK_BORDER}`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                    }}>
                        <EventBusyIcon sx={{ color: BURGUNDY, fontSize: 22 }} />
                    </Box>
                    <Box sx={{ flex: 1, pr: 3 }}>
                        <Typography sx={{ fontWeight: 700, fontSize: '17px', color: '#1a1a2e', lineHeight: 1.2 }}>
                            Add Block Hours
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#6B7280', mt: '2px' }}>
                            Mark a date / time range as unavailable.
                        </Typography>
                    </Box>
                    <IconButton
                        size="small"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute', top: 10, right: 10,
                            color: '#6B7280', borderRadius: '8px',
                            width: 32, height: 32,
                            border: `1px solid ${PINK_BORDER}`,
                            '&:hover': { background: PINK_BG, color: BURGUNDY },
                        }}
                    >
                        <CloseIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                </Box>

                {/* Body */}
                <Box sx={{
                    flex: 1, overflowY: 'auto', position: 'relative',
                    p: { xs: 2, sm: 3 },
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        '& fieldset': { borderColor: PINK_BORDER },
                        '&:hover fieldset': { borderColor: BURGUNDY },
                        '&.Mui-focused fieldset': { borderColor: BURGUNDY, borderWidth: '1.5px' },
                    },
                }}>
                    {loading && <Waveloading cover />}

                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormLabel sx={{ ...labelStyles, color: BURGUNDY, fontSize: 12, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', mb: 0.75 }}>Date</FormLabel>
                                <FormDateInput
                                    name={"date"}
                                    errors={errors}
                                    touched={touched}
                                    values={values}
                                    handleChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormLabel sx={{ ...labelStyles, color: BURGUNDY, fontSize: 12, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', mb: 0.75 }}>Start Time</FormLabel>
                                <Autocomplete
                                    name={'start_time'}
                                    options={timeSlots}
                                    getOptionLabel={(option) => option}
                                    value={values?.start_time}
                                    renderInput={(params) => {
                                        const { inputProps, helperText, error, ...rest } = params;
                                        return (<TextField {...rest} inputProps={{ ...inputProps }} sx={inputStyle} placeholder={"Start Time"} />);
                                    }}
                                    onChange={(event, newValue) => { setFieldValue("start_time", newValue); }}
                                />
                                {errors?.start_time && touched?.start_time && <FormHelperText sx={{ color: '#CB3838', mx: 0 }}>{errors?.start_time}</FormHelperText>}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormLabel sx={{ ...labelStyles, color: BURGUNDY, fontSize: 12, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', mb: 0.75 }}>End Time</FormLabel>
                                <Autocomplete
                                    name={'end_time'}
                                    options={timeSlots}
                                    getOptionLabel={(option) => option}
                                    value={values?.end_time}
                                    renderInput={(params) => {
                                        const { inputProps, helperText, error, ...rest } = params;
                                        return (<TextField {...rest} inputProps={{ ...inputProps }} sx={inputStyle} placeholder={"End Time"} />);
                                    }}
                                    onChange={(event, newValue) => { setFieldValue("end_time", newValue); }}
                                />
                                {errors?.end_time && touched?.end_time && <FormHelperText sx={{ color: '#CB3838', mx: 0 }}>{errors?.end_time}</FormHelperText>}
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <FormLabel sx={{ ...labelStyles, color: BURGUNDY, fontSize: 12, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', mb: 0.75 }}>Notes</FormLabel>
                                    <Box sx={{
                                        position: 'relative',
                                        border: `1px solid ${PINK_BORDER}`,
                                        borderRadius: '10px',
                                        background: '#fff',
                                        transition: 'border-color 0.15s',
                                        '&:focus-within': { borderColor: BURGUNDY, boxShadow: '0 0 0 2px rgba(167,44,104,0.10)' },
                                    }}>
                                        <textarea
                                            rows={4}
                                            name='notes'
                                            maxLength={NOTE_MAX_LENGTH}
                                            value={values?.notes}
                                            onChange={handleChange}
                                            placeholder="Add a note for this block (e.g. lunch, meeting)…"
                                            style={{
                                                width: '100%',
                                                resize: 'vertical',
                                                padding: '10px 12px',
                                                border: 'none',
                                                outline: 'none',
                                                borderRadius: '10px',
                                                fontFamily: 'inherit',
                                                fontSize: '14px',
                                                color: '#1a1a2e',
                                                background: 'transparent',
                                                boxSizing: 'border-box',
                                            }}
                                        />
                                    </Box>
                                    {!!noteLimitError(values?.notes) && (
                                        <FormHelperText sx={{ color: '#EB5757', mx: 0 }}>{noteLimitError(values?.notes)}</FormHelperText>
                                    )}
                                    {errors?.notes && touched?.notes && (
                                        <FormHelperText sx={{ color: '#CB3838', mx: 0 }}>{errors?.notes}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>

                        {/* Footer */}
                        <Box sx={{
                            mt: 3, pt: 2.5,
                            borderTop: `1px solid ${PINK_BORDER}`,
                            display: 'flex', justifyContent: 'flex-end', gap: 1,
                        }}>
                            <Button
                                onClick={handleClose}
                                sx={{
                                    height: 42, px: 3, borderRadius: '10px',
                                    textTransform: 'capitalize', fontSize: '13px', fontWeight: 600,
                                    color: '#fff',
                                    backgroundColor: '#EB5757',
                                    border: '1px solid #EB5757',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        backgroundColor: '#fff',
                                        color: '#EB5757',
                                        border: '1px solid #EB5757',
                                        boxShadow: 'none',
                                    },
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                sx={{
                                    height: 42, px: 3, borderRadius: '10px',
                                    textTransform: 'capitalize', fontSize: '13px', fontWeight: 700,
                                    color: '#fff',
                                    background: "linear-gradient(135deg, #27AE60 0%, #1E8449 100%)",
                                    border: '1px solid #27AE60',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        background: '#219653',
                                        color: '#fff',
                                        border: '1px solid #27AE60',
                                        boxShadow: 'none',
                                    },
                                }}
                            >
                                Save Block Hours
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Drawer>
        </Grid>
    );
};

export default StaffBreakTimeModal;